/**
 * Per-list PostgREST nulls-last.
 *
 * ra-data-postgrest turns this into `order=<field>.<dir>.nullslast`.
 * The provider-wide `sortOrder` is left alone: DESC lists that do not opt in
 * keep today's global token, and this flag is what a single list asks for.
 */
export const nullsLastMeta = { nullslast: true } as const;
